import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Landmark, Loader2, CheckCircle } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 8) return setError("Password must be at least 8 characters.");
    if (password !== confirm) return setError("Passwords do not match.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => nav("/login"), 2500);
    } catch (err) {
      setError(apiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-ink p-6">
      <div className="w-full max-w-sm bg-white rounded-md shadow-2xl p-8">
        <div className="flex items-center gap-2 mb-6">
          <Landmark className="text-brass" strokeWidth={1.5} size={26} />
          <span className="font-serif text-xl text-ink">KKPKLB</span>
        </div>
        {done ? (
          <div className="text-center py-6" data-testid="reset-done">
            <CheckCircle className="text-positive mx-auto mb-3" size={40} />
            <h1 className="font-serif text-2xl text-ink">Password set</h1>
            <p className="text-sm text-slate mt-2">Redirecting to sign in…</p>
          </div>
        ) : !token ? (
          <div className="text-center py-6">
            <p className="text-brick">Invalid reset link.</p>
            <Link to="/login" className="text-brass text-sm mt-3 inline-block">Back to sign in</Link>
          </div>
        ) : (
          <>
            <h1 className="font-serif text-2xl text-ink">Set your password</h1>
            <p className="text-sm text-slate mt-1 mb-6">Tetapkan kata laluan anda.</p>
            {error && <div className="mb-4 bg-brick-bg text-brick px-3 py-2 rounded-sm text-sm">{error}</div>}
            <form onSubmit={submit} className="space-y-4">
              <input
                type="password" placeholder="New password" required value={password}
                onChange={(e) => setPassword(e.target.value)} data-testid="reset-password"
                className="w-full bg-white border border-slate-300 rounded-sm px-3 py-2.5 text-sm focus:border-brass focus:ring-1 focus:ring-brass outline-none text-ink"
              />
              <input
                type="password" placeholder="Confirm password" required value={confirm}
                onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm"
                className="w-full bg-white border border-slate-300 rounded-sm px-3 py-2.5 text-sm focus:border-brass focus:ring-1 focus:ring-brass outline-none text-ink"
              />
              <button type="submit" disabled={loading} data-testid="reset-submit"
                className="w-full bg-ink text-white hover:bg-ink-light py-2.5 rounded-sm transition-colors text-sm font-medium flex items-center justify-center gap-2 disabled:opacity-60">
                {loading && <Loader2 size={16} className="animate-spin" />} Set Password
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
